export default {
  analytics: {
    header: {
      title: 'Métricas',
      back: 'Volver para mis páginas',
      subtitle: {
        edit: 'Editar',
      },
    },
    info: {
      cacheDelay: '*Las métricas de la página pueden tardar hasta un día en actualizarse',
    },
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversiones',
      conversionRate: 'Tasa de Conversión',
      showEmails: 'Ver e-mails capturados',
      conversionType: 'Identificador de la conversión',
      subscriptionIdentifier: 'Inscripción en el formulario de e-mail',
      linkIdentifier: 'Link {identifier}' },
    duration: {
      title: 'Duración media',
    },
    visitors: {
      title: 'Visitantes',
      unique: 'Únicos',
      local: 'Lugar',
      country: 'País',
      visits: 'Visitas',
      showMap: 'Ver origen de los visitantes',
    },
  },
  date: {
    simpleFormat: 'dd/MM/yyyy',
    dateAndTime: 'DD/MM/YYYY HH:mm',
    simpleFormatDash: 'DD-MM-YYYY',
  },
  emailsList: {
    title: 'E-mails capturados',
    emailColumn: 'Dirección de E-mail',
    dateColumn: 'Fecha',
    searchPlaceholder: 'Buscar dirección',
    capturedEmails: 'Ningún e-mail capturado | 1 e-mail capturado | {count} e-mails capturados',
    export: {
      button: 'Exportar',
      fileName: 'Lista de e-mails capturados',
    },
  },
  pagination: {
    previous: 'Anterior',
    next: 'Próximo',
  },
  chart: {
    period: 'Período',
    date: {
      from: 'De',
      to: 'a',
      invalidPeriod: 'La fecha inicial del periodo debe ser menor de que la fecha final. Por favor, selecciona otro período de fechas.',
    },
    filter: 'Filtrar y exhibir gráfico',
    granularity: {
      hour: {
        label: 'Hora',
        format: 'DD/MM [a las] HH[h]',
      },
      day: {
        label: 'Día',
        format: 'DD/MM',
      },
    },
    noData: 'Sin datos en el período',
  },
  locations: {
    title: 'Origen de los visitantes',
    searchPlaceholder: 'Filtrar localidad',
    visitors_percent: '% de los visitantes',
    visitors: 'Ningún visitante | 1 visitante | {count} visitantes',
    cities: 'de 1 ciudad | de {count} ciudades',
    countries: 'en 1 país | en {count} países',
    not_identified: 'No identificado',
  },
  notifications: {
    noNotifications: 'No hay notificaciones nuevas.',
    unableLoad: 'No pudimos cargar notificaciones en este momento.',
  },
  loading: {
    title: 'Estamos procesando la acción. Espere mientras cargamos los datos.',
    subtitle: 'La solicitud puede tardar unos minutos.',
  },
  error: {
    notFound: {
      title: 'No se pueden encontrar métricas para esta página',
      buttons: {
        home: 'Ir a la página de inicio',
      },
    },
    metricsProcess: {
      title: 'Tuvimos un error por aquí',
      subtitle: 'No podemos cargar esta página en este momento, pero estamos trabajando para resolver el problema. Vuelve a intentarlo en unos minutos. Si el problema persiste, puede ponerse en contacto con nuestro Soporte.',
      buttons: {
        home: 'Intentar nuevamente',
        support: 'Hablar con soporte',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/es.js